import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Box, Typography } from '@mui/material'
import PageContainer from '@/components/ui/containers/PageContainer'
import { OfflineStatusIndicator } from './OfflineStatusIndicator'

export function OfflineInitializing() {
  useLingui()
  return (
    <PageContainer>
      <OfflineStatusIndicator />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <Typography variant="body1" color="text.secondary">
          {/* {t('offline.database.initializing')} */}
          <Trans>Initializing offline database...</Trans>
        </Typography>
      </Box>
    </PageContainer>
  )
}
